import { render, staticRenderFns } from "./AzDialog.vue?vue&type=template&id=a99318e6&"
import script from "./AzDialog.vue?vue&type=script&lang=js&"
export * from "./AzDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports